import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

import axios from 'axios';

import * as Sentry from '@sentry/browser';

const authmodule = {
	state: {
		logged: !!window.localStorage.getItem('_token'),
		name: '',
		token: '',
		id: '',
		usertype: ''
	},
	getters: {
		getLogged: state => state.logged,
		getName: state => state.name,
		getid: state => state.id,
		getToken: state => state.token,
		getusertype: state => state.usertype
	},
	actions: {
		requestlogin: ({ commit, dispatch, getters }, logindata) => {

			return new Promise((resolve, reject) => {
				console.log(logindata)
				axios.post('/ws/login', logindata).then(response => {

					let result = response.data;
					console.log(result)
					if (result.logged) {
						resolve(true);
						dispatch('setlogged', result).then(r => {
							resolve(r);
						});
					} else {
						(!!result.error) ? commit('setErrorMensaje', result.error) : null;
						reject(false);
					}

				}).catch(error => {
					reject(false);
				});
			});
		},
		requestLogout: ({ commit, dispatch }) => {
			return new Promise((resolve, reject) => {
				commit('setLogout');
				dispatch('turnOffRGPD');
				commit('removeEncuestas');
				resolve(true);
			});
		},
		checkLogged({ commit }) {

			return new Promise((resolve, reject) => {

				let when = Number(window.localStorage.getItem('sessionInit'));
				let now = new Date().getTime();



				if (!!when) {


					if (when < (now - 7200000)) {
						commit("setLogout");
						resolve(false);
					} else {
						commit('setLogged');
						resolve(true);
					}

				} else {
					resolve(true);
				}
			});


		},
		setlogged({ commit,dispatch }, result) {
			window.localStorage.setItem('_token', result.token);
			window.localStorage.setItem('_id', result.id);
			window.localStorage.setItem('_name', result.user);
			window.localStorage.setItem('_usertype', result.idPerfil);

			let date = new Date().getTime();

			window.localStorage.setItem('sessionInit', date);


			commit('setLogged', result);

			commit('setType', result.entidad)


			if(result.encuestas.jsEncuestaMini){
				console.log('inside');
				dispatch('setEncuestas', result.encuestas.jsEncuestaMini)
			}

			Sentry.setUser(
				{ "username": result.user },
				{ "id": result.id }
			);

			Sentry.setTag("version", getters.getVersion);

			if (!!result.textoAceptacion) {
				dispatch('turnOnRGPD');
				commit('setTextRGPD', result.textoAceptacion);
			}
			resolve(true);
		}


	},
	mutations: {
		setLogged(state, data) {

			if (!!window.localStorage.getItem('_token')) {

				const token = window.localStorage.getItem("_token");
				const id = window.localStorage.getItem("_id");
				const name = window.localStorage.getItem("_name");
				const usertype = window.localStorage.getItem("_usertype");




				axios.defaults.headers.common['token'] = token;
				axios.defaults.headers.common['id'] = id;

				state.logged = true;
				state.token = token;
				state.id = id;
				state.name = name;
				state.usertype = (usertype == 1) ? 'Empleo' : 'Practicas';
			}

		},
		setLogout(state) {
			state.logged = false;
			window.localStorage.clear();
			window.sessionStorage.clear();
		},
	}
}

export default authmodule;




// WEBPACK FOOTER //
// ./src/store/authmodule.js